import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useHistory } from "react-router";
import $ from "jquery";
import axios from "axios";
import ReqService from './../../request/service';
import Waiter from './../../assets/gif/blueCircle.gif';
import CopySound from './../../assets/sound/beep07a.wav';
import { createGlobalStyle } from 'styled-components';
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from './../../constants';
import {stringToHex} from "./../forms/validator";
import Resizer from "react-image-file-resizer";
const GlobalStyles = createGlobalStyle`

`;
let editColInfo={
	assetType:{},
	assetName:{label:"Asset Name"},
	implementAgency:{label:"Implementing Agency"},
	fundingAgency:{label:"Funding/Scheme Agency"},
	userAgency:{label:"User Agency"},
	assetDescription:{label:"Asset Description"},
	panchayat:{label:"Panchayat"},
	address:{label:"Address"},
	village:{label:"Village"},
	block:{label:"Block"},
	beneficiary:{label:"Beneficiary"},
	agrCost:{label:"Agreement Cost"},
	agrDate:{label:"Agreement Date"},
	estCost:{label:"Estimeted Cost"},
	estWorkStartDate:{label:"Estimated Work Start Date"},
	estWorkCompleteByDays:{label:"Estimated Completion days"},
	workStartDate:{label:"Work Start Date"},
	workFinishDate:{label:"Work Finsih Date"},
	workStatus:{label:"Work Status"},
	workProgress:{label:"Work Progress"},
	lat:{label:"Latitude"},
	lng:{label:"Longitude"},
	name:{label:"Contractor Name"},
	photos:{label:"Photo"},
	handedOver:{label:"Handed Over"},
	inUse:{label:"In use status"},
	contractor:{}
};
const JComponent = (props) => { 
	const navigate=useNavigate();
	const [disabled,setDisabled]=useState(false);
	const [rows,setRows]=useState([]);
	const [fetchOnReq,setFecthOnReq]=useState(false);
	const [assetsCategoryList,setAssetsCategoryList]=useState([]);
	const [implAgencyList,setImplAgencyList]=useState([]);
  	const [fundingAgencyList,setFundingAgencyList]=useState([]);
  	const [userAgencyList,setUserAgencyList]=useState([]);
	const [showImageBox,setShowImageBox]=useState(false);
	const [showQRBox,setShowQRBox]=useState(false);
	const [selectedImages,setSelectedImages]=useState([]);
	const [selectedQRImage,setSelectedQRImage]=useState("");
	const [isEditOpened,setIsEditOpend]=useState(false);
	const [editPanelShow,setEditPanelShow]=useState(false);
	const [assetId,setAssetId]=useState("");

	const [remarks,setRemarks]=useState([]);
	const [payments,setPayments]=useState([]);
	
	const [reqWaitUpload,setReqWaitUpload]=useState(false);
	const [newImages,setNewImages]=useState([]);

	let _TX=1;
	useEffect(()=>{ 
		console.log(window.location);
		let params=window.location.search;
		params=(params!=null && params!=undefined)?params.substring(1):"";

		console.log(params);
		if(_TX==1){ _TX++;
		loadAssetCategoryList();
		loadImplAgencyList();
		loadUserAgencyList();
		loadFundingAgencyList();
		getRemarks(params);
		getPayment(params);
		let _rows=[];
		setRows([]);
			let _d={
					token:localStorage.getItem("_xoxex"),
					assetId:params,
				};
			setAssetId(params);	
			let idata=stringToHex(JSON.stringify(_d));	
			setFecthOnReq(true);	
			var config = {
				method: 'post',
				url: API_CORE_SERVER+"/api/document/get-document.php",
				headers: { 
					'Content-Type': 'application/x-www-form-urlencoded',
					//'Content-Type': 'application/json', 
				},
				data:"i="+idata
			  };
			  axios(config).then(response=>{
				if(response.status===200 && response.data){
					let data=response.data;
					if(data.status===1 && data.data && data.data.length>0){
						let records=data.data;
						for(let i=0;i<records.length;i++){
							let assetId=records[i].assetId;
							try{
									let rec=JSON.parse(records[i].data);
									//console.log(rec);
									_rows.push({ 
										
										assetId:assetId,
										je:rec.assetInfo.je,
										ae:rec.assetInfo.ae,
										ee:rec.assetInfo.ee,
										assetType:rec.assetInfo.assetType,
										assetName:rec.assetInfo.assetName,
										implementAgency:rec.assetInfo.implementAgency,
										fundingAgency:rec.assetInfo.fundingAgency,
										userAgency:rec.assetInfo.userAgency,
										assetDescription:rec.assetInfo.assetDescription,
										panchayat:rec.assetInfo.panchayat,
										address:rec.assetInfo.address,
										village:rec.assetInfo.village,
										block:rec.assetInfo.block,
										beneficiary:rec.assetInfo.beneficiary,
										agrCost:rec.assetDetail.agrCost,
										agrDate:rec.assetDetail.agrDate,
										estCost:rec.assetDetail.estCost,
										estWorkStartDate:rec.assetDetail.estWorkStartDate,
										estWorkCompleteByDays:rec.assetDetail.estWorkCompleteByDays,
										workStartDate:rec.assetDetail.workStartDate,
										workFinishDate:rec.assetDetail.workFinishDate,
										workStatus:rec.assetDetail.workStatus,	// Ongoing | Completed | Paused
										workProgress:rec.assetDetail.workProgress, // 5 10 15 20.....100
										lat:rec.assetDetail.lat,
										lng:rec.assetDetail.lng,
										name:rec.contractorInfo.name,
										photos:rec.assetDetail.photos,
										contractor:rec.contractorInfo,
										actionRemarks:rec.actionRemarks,
										handedOver:rec.assetDetail.handedOver!=undefined?rec.assetDetail.handedOver:"No",
										inUse:rec.assetInfo.inUse!=undefined?rec.assetInfo.inUse:"No"
									});
								}catch(e){
									console.log("exp:assetId:"+assetId);
								}
						}
					}
				}
				
				setFecthOnReq(false);
			});
			setRows(_rows);
			
		}
		
	},[]);
	
	const getAssetType=(_catId)=>{
		for(let i=0;i<assetsCategoryList.length;i++){
			if(assetsCategoryList[i].catId===_catId) return(assetsCategoryList[i].catName);
		}
		return(_catId);
	}
	const getImplAgencyById=(_id)=>{
		for(let i=0;i<implAgencyList.length;i++){
			if(implAgencyList[i].implAgencyId===_id) return(implAgencyList[i].implAgencyName);
		}
		return(_id);
	}
	const getUserAgencyById=(_id)=>{
		for(let i=0;i<userAgencyList.length;i++){
			if(userAgencyList[i].userAgencyId===_id) return(userAgencyList[i].userAgencyName);
		}
		return(_id);
	}
	const loadAssetCategoryList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_asset_category.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hello'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setAssetsCategoryList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadImplAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_impl_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hello'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setImplAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadFundingAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_funding_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hello'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setFundingAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadUserAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_user_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hello'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setUserAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	const copyi=(e)=>{
		//window.document.getElementById('audiox').play();
		//console.log(e.target.id);
		window.navigator.clipboard.writeText(e.target.getAttribute("a"));
	}
	const [editLabel,setEditLabel]=useState("");
	const [editKey,setEditKey]=useState("");
	const [editOldValue,setEditOldValue]=useState("");
	const [editNewValue,setEditNewValue]=useState("");
	const [storageUnder,setStorageUnder]=useState("");
	const editCol=(_key,_oldV,_storage)=>{
		let label=editColInfo[_key].label;
		setEditLabel(label);
		setEditKey(_key);
		setEditOldValue(_oldV);
		setStorageUnder(_storage);
		setEditPanelShow(true);
	}
	const updateRec=async()=>{
		let _d={
			    email:localStorage.getItem("_xoxem"),
				assetId:assetId,
				skey:storageUnder,
				key:editKey,
				ov:editOldValue,
				nv:editNewValue
		};
		let idata=stringToHex(JSON.stringify(_d));
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/document/update.php",
			headers: { 
				'Content-Type': 'application/x-www-form-urlencoded',
				//'Content-Type': 'application/json', 
			},
			data:"i="+idata
		  };
			axios(config)
			.then((response)=>{
				console.log(response);
				if(response.status===200 && response.data){
					document.location=window.location.href;
				}
			}).catch((response)=>{
				console.log(response);
			})
	}
	const submitRemark=async(e)=>{
		let remark=document.getElementById("remarkTa").value;
		remark=encodeURIComponent(remark);
		let _d={
						email:localStorage.getItem("_xoxem"),
						assetId:assetId,
						remark:remark
				};
				
				let idata=stringToHex(JSON.stringify(_d));
				var config = {
					method: 'post',
					url: API_CORE_SERVER+"/api/document/update-remark.php",
					headers: { 
						'Content-Type': 'application/x-www-form-urlencoded',
						//'Content-Type': 'application/json', 
					},
					data:"i="+idata
				};
					axios(config)
					.then((response)=>{
						console.log(response.data);
						if(response.status===200 && response.data){
							if(response.data.status===1) { 
								document.getElementById("remarkTa").value="";	
							getRemarks(assetId );
							}
						}
					}).catch((response)=>{
						console.log(response);
					})
	}
	const getRemarks=async(_id)=>{
		
		let _d={
						email:localStorage.getItem("_xoxem"),
						assetId:_id
				};
				
				let idata=stringToHex(JSON.stringify(_d));
				var config = {
					method: 'post',
					url: API_CORE_SERVER+"/api/document/get-remarks-of.php",
					headers: { 
						'Content-Type': 'application/x-www-form-urlencoded',
						//'Content-Type': 'application/json', 
					},
					data:"i="+idata
				};
					axios(config)
					.then((response)=>{
						console.log(response.data);
						if(response.status===200 && response.data){
							let data=response.data;
							if(data.status===1) setRemarks(data.data);
						}
					}).catch((response)=>{
						console.log(response);
					})
	}
	const getPayment=async(_id)=>{
		
		let _d={
						email:localStorage.getItem("_xoxem"),
						assetId:_id
				};
				
				let idata=stringToHex(JSON.stringify(_d));
				var config = {
					method: 'post',
					url: API_CORE_SERVER+"/api/payment/payment.listof.php",
					headers: { 
						'Content-Type': 'application/x-www-form-urlencoded',
						//'Content-Type': 'application/json', 
					},
					data:"i="+idata
				};
					axios(config)
					.then((response)=>{
						console.log(response.data);
						if(response.status===200 && response.data){
							let data=response.data;
							if(data.status===1) setPayments(data.data);
						}
					}).catch((response)=>{
						console.log(response);
					})
	}
	const fileChangedHandler=(event)=>{
		var fileInput = false;
		if (event.target.files[0]) {
		  fileInput = true;
		}
		if (fileInput) {
		  try {
			Resizer.imageFileResizer(
			  event.target.files[0],
			  160,
			  160,
			  "JPEG",
			  100,
			  0,
			  (uri) => {
				
				
				uploadIcon(event,uri);
			  },
			  "base64",
			  96,
			  96
			);
		  } catch (err) {
			console.log(err);
		  }
		}
	}
	const uploadIcon=async(_event,_uri)=>{
		
		try {
			setReqWaitUpload(true);
			let _file=_event.target.files[0];
			//let dataImage=URL.createObjectURL(_event.target.files[0]);
			const formData = new FormData();
			formData.append('file', _file);
			formData.append('assetId', assetId);
			formData.append('email', localStorage.getItem("_xoxem"));
			let response =await axios({
				method: 'post',
				url: API_CORE_SERVER+"/api/upload/image-update.php",
				headers: { 
					'accept': 'application/json',
					'Content-Type': 'multipart/form-data'
				},
				data : formData 
			});
			if(response.status===200){
				let data=response.data;
				if(data.status===1){
					document.location=window.location.href;
				}
				else {
					alert(""+data.msg);
				}
			}
			
		  } catch(error) {
			console.log(error)
		  }
		  finally{
			setReqWaitUpload(false);
		  }
		
	}
	const getDelayDays=(startDate,days,workFinishDate,workStatus)=>{
		console.log(" DAYS="+days);
		const sdate=new Date(startDate);
		const cdate=new Date();
		let fdd=0;
		if(workStatus=="Completed"){
			const fdate=new Date(workFinishDate);
			const dt = fdate.getTime() - sdate.getTime();
			const dd=Math.round(dt/(1000*3600*24))-parseInt(days);
			return(dd);
		}else{
		const dt = cdate.getTime() - sdate.getTime();
		
		const dd=Math.round(dt/(1000*3600*24))-parseInt(days);
		return(dd);
		}
	}
	const getExpectedWorkProgress=(startDate,days)=>{
		const pf=100/days;
		const sdate=new Date(startDate);
		const cdate=new Date();
		const dt = cdate.getTime() - sdate.getTime();
		const dd=Math.round(dt/(1000*3600*24));
		if(dd>=days) return("100%");
		else return(""+parseInt(dd*pf)+"%");
	}
	return (
        <>
		<GlobalStyles />
		<div className='row'>
		<h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-boxes'></i>Project Details</h5>
						
		<div className='col-12'>
			<div className='card'>
			<div className="card-body" style={{overflowX:"scroll"}}>
			{fetchOnReq===true && 
				<>
					<img src={Waiter} className='waiter-md'/>
				</>
			}
			{(fetchOnReq===false && rows.length>=1) && 
                <>
				{ rows && rows.map((item,i)=>{
								return(
									i===0?
                                    <>
									<div className="d-flex">
										<div className="flex-grow-1">
											<div className="d-flex align-items-end img-md">
													{
													item && item.photos && item.photos.split(",").map((ph,iph)=>{
													return(iph>0?
															
																<img src={API_CORE_SERVER+"/_apithumbnail/"+ph}
																data={ph}
																className="cursor-pointer"
																onClick={e=>{
																	
																	setSelectedImages([e.target.getAttribute("data")]);
																	setShowImageBox(true);
																}}
																/>
															
															:<></>
														)
													})}
													
													{isEditOpened===true && 
														
														<div className='mt-2 text-center position-relative'>
															<input type="file" className='form-control position-absolute' onChange={fileChangedHandler} 
															style={{backgroundColor:'#481886',zIndex:999,top:0,opacity:0}}
															disabled={reqWaitUpload}
															/>
															<button className='btn rounded-pill px-4 -py-4 text-white fw-bold'
															style={{backgroundColor:'#481886'}}
															onClick={e=>{}}
															disabled={reqWaitUpload}
															>
																{reqWaitUpload===true?
																		<><img src={Waiter} style={{width:'22px'}} /></>
																	:
																		<> <i className="bi bi-arrow-up"></i> Upload Photo </>
																}
															</button>
														</div>
													}
											</div>
										</div>		
										<div className="cursor-pointer img-md">
												{/*<img 
												src={"https://domainname....in/api/document/get-qr-code.php?ai="+item.assetId} 
												onClick={e=>{
																
													setSelectedQRImage(e.target.getAttribute("src"));
													setShowQRBox(true);
												}}
												/>*/}
										</div>
									</div>
									<div className='mt-4 d-flex'>
										<div className="flex-grow-1">
										<button className="btn btn-warning px-4" 
										onClick={e=>{
												setIsEditOpend(!isEditOpened);
										}}>{isEditOpened==false?<>Edit</>:<>Cancel Edit</>} </button>
										</div>
										<button className="btn btn-success px-4" 
										onClick={e=>{
											navigate(URLPREFIX+"/payment/add",{state:{assetId:assetId}});
										}}>Payment</button>

									</div>
									<div className='d-flex'>
										<div className='formDiv flex-fill'>
											<div className='formLabel'>Work progress</div>
											<div className='formValue'>
											{(item.actionRemarks!=null && item.actionRemarks.key==="workProgress" )?
											<span className="badge bg-light text-black">Previous: {item.actionRemarks.old}% </span>
											:<></>}
											<span className="badge bg-success text-white">Current: {(item.workProgress)}%</span>
											{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('workProgress',item.workProgress,'assetDetail')}></span>} 
											<span className="ms-2 badge bg-warning text-black">Expected Progress: {getExpectedWorkProgress(item.workStartDate,item.estWorkCompleteByDays)}</span>
											{getDelayDays(item.workStartDate,item.estWorkCompleteByDays,item.workFinishDate,item.workStatus)<=0?
												<span className="ms-2 badge bg-success text-white">Delay Days: {getDelayDays(item.workStartDate,item.estWorkCompleteByDays,item.workFinishDate,item.workStatus)}</span>
												:
												<span className="ms-2 badge bg-danger text-white">Delay Days: {getDelayDays(item.workStartDate,item.estWorkCompleteByDays,item.workFinishDate,item.workStatus)}</span>
											}
											
											
											
											</div>
										</div>	
										<div>
											<div className='formLabel'>Payment List</div>
											{
												payments!=null && payments.length>=1 ?
												<>
													<table className='table table-sm' >
														<thead>
															<tr>
																<td><b>Payment.Date</b></td>
																<td align="right"><b>Amount</b></td>
																<td><b>Remarks</b></td>
															</tr>
														</thead>
														<tbody>
															{
																payments.map((item,index)=>{
																	return(
																			<tr>
																				<td>{item.payDate}</td>
																				<td align="right">{item.paymentAmount}</td>
																				<td>{item.remark}</td>
																			</tr>
																	);		
																})
															}
														</tbody>
													</table>
												</>
												:
												<><h5>No Payment Found</h5></>
											}
										</div>
									</div>
									<div className="d-flex">
										<div className='formDiv'>
											<div className='formLabel'>Handed Over</div>
											<div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('handedOver',item.handedOver,'assetDetail')}></span>} {(item.handedOver)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>In Use</div>
											<div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('inUse',item.inUse,'assetInfo')}></span>} {(item.inUse)}</div>
										</div>
									</div>
									<div className='d-flex'>&nbsp;</div>
									<div className="d-flex">
										<div className='w-100'>
											<div className="accordion" id="accordionExample">
												<div className="accordion-item">
													<h2 className="accordion-header" id="headingOne">
													<button className="accordion-button fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
														Remarks
													</button>
													</h2>
													<div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
														<div className="accordion-body">
															<div className="mb-3">
																<label for="exampleFormControlTextarea1" className="form-label">Add Remark</label>
																<textarea className="form-control" id="remarkTa" rows="3"></textarea>
															</div>
															<div className="mb-3 text-end">
																<button type="button" className="btn btn-warning" onClick={e=>submitRemark(e)}>Submit Remark</button>
															</div>
															<div className="mb-3">
																{remarks && remarks.map((item,index)=>{
																		return(
																			<>
																				<div className='fs85rem text-gray-dark mb-2'>{item.idate}, {item.email}</div>
																				<div className='fs85rem text-gray-hard mb-4'>
																					{
																						decodeURIComponent(item.data)
																					}
																				</div>
																			</>
																		)
																})}
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className='d-flex mt-4'>&nbsp;</div>
									<div className="d-flex">
										<div className='formDiv'>
											<div className='formLabel'>Implementing Agency</div>
											<div className='formValue'> {getImplAgencyById(item.implementAgency)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Funding Agency</div>
											<div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('fundingAgency',item.fundingAgency,'assetInfo')}></span>} {item.fundingAgency}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>User Agency</div>
											<div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('userAgency',item.userAgency,'assetInfo')}></span>} {getUserAgencyById(item.userAgency)}</div>
										</div>		
									</div>
									<div className="d-flex">
										<div className='formDiv'>
											<div className='formLabel'>J.E</div>
											<div className='formValue'> {item.je}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>A.E</div>
											<div className='formValue'>{item.ae}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>E.E</div>
											<div className='formValue'>{item.ee}</div>
										</div>		
									</div>
                                    <div className='formDiv'>
                                        <div className='formLabel'>Asset Name</div>
                                        <div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('assetName',item.assetName,'assetInfo')}></span>} {item.assetName}</div>
                                    </div>
                                    <div className='formDiv'>
                                        <div className='formLabel'>Description</div>
                                        <div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('assetDescription',item.assetDescription,'assetInfo')}></span>} {item.assetDescription}</div>
                                    </div>
                                    <div className='formDiv'>
                                        <div className='formLabel'>Asset Type</div>
                                        <div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('assetType',item.assetType,'assetInfo')}></span>} {getAssetType(item.assetType)}</div>
                                    </div>

                                    <div className='formDiv'>
                                        <div className='formLabel'>Address</div>
                                        <div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('address',item.address,'assetInfo')}></span>} {item.address}</div>
                                    </div>

									<div className="d-flex">
										<div className='formDiv'>
											<div className='formLabel'>village</div>
											<div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('village',item.village,'assetInfo')}></span>} {item.village}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Panchayat</div>
											<div className='formValue'>{item.panchayat}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>block</div>
											<div className='formValue'>{item.block}</div>
										</div>
									</div>

									<div className='formDiv'>
                                        <div className='formLabel'>Beneficiary</div>
                                        <div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('beneficiary',item.beneficiary,'assetInfo')}></span>} {item.beneficiary}</div>
                                    </div>

									<div className="d-flex">
										<div className='formDiv'>
											<div className='formLabel'>Agreement cost</div>
											<div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('agrCost',item.agrCost,'assetDetail')}></span>} {(item.agrCost)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Agreement date</div>
											<div className='formValue'>{(item.agrDate)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Estimeted cost</div>
											<div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('estCost',item.estCost,'assetDetail')}></span>} {(item.estCost)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Estimeted work start date</div>
											<div className='formValue'>{(item.estWorkStartDate)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Estimeted Work Finsh by days</div>
											<div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('estWorkCompleteByDays',item.estWorkCompleteByDays,'assetDetail')}></span>} {(item.estWorkCompleteByDays)}</div>
										</div>
									</div>	

									<div className="d-flex">
										<div className='formDiv'>
											<div className='formLabel'>Work start date</div>
											<div className='formValue'>{(item.workStartDate)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Work finish date</div>
											<div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('workFinishDate',item.workFinishDate,'assetDetail')}></span>} {(item.workFinishDate)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Work status</div>
											<div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('workStatus',item.workStatus,'assetDetail')}></span>} {(item.workStatus)}</div>
										</div>
										
										
									</div>		
									
									<div className="d-flex">
										<div className='formDiv'>
											<div className='formLabel'>Latitude</div>
											<div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('lat',item.lat,'assetDetail')}></span>} {(item.lat)}</div>
										</div>
										<div className='formDiv'>
											<div className='formLabel'>Longitude</div>
											<div className='formValue'>{isEditOpened===true && <span className="cursor-pointer editCol" onClick={e=>editCol('lng',item.lng,'assetDetail')}></span>} {(item.lng)}</div>
										</div>
									</div>
									
									<div className="card bg-light">
										<div className="card-body">
											<h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-boxes'></i>Contractor Details</h5>
											<div className="d-flex">
												<div className='formDiv'>
													<div className='formLabel'>Contractor Name</div>
													<div className='formValue'>{(item.contractor.name)}</div>
														
												</div>	
												<div className='formDiv'>
													<div className='formLabel'>Contractor Registration No</div>
													<div className='formValue'>{(item.contractor.regNo)}</div>
												</div>
												<div className='formDiv'>
													<div className='formLabel'>Contact No</div>
													<div className='formValue'>{(item.contractor.contactNo)}</div>
												</div>
											</div>	
											<div className='formDiv'>
													<div className='formLabel'>Address</div>
													<div className='formValue'>{(item.contractor.address)}</div>
											</div>		
											<div className="d-flex">
												<div className='formDiv'>
													<div className='formLabel'>District</div>
													<div className='formValue'>{(item.contractor.district)}</div>
												</div>
												<div className='formDiv'>
													<div className='formLabel'>State</div>
													<div className='formValue'>{(item.contractor.state)}</div>
												</div>
												
											</div>
										</div>
									</div>

                                    </>
                                    :<></>	
								)
					})
					}
				</>	
			}
			</div>	
			</div>
		</div>
		
	</div>	
	
	{editPanelShow===true &&
	<>
	<div className="position-fixed start-0 top-0 vw-100 vh-100 bg-light" style={{zIndex:99999999,opacity:0.95}}>
		<div className="d-flex justify-content-end p-4">
			<div className="cursor-pointer text-dark" onClick={()=>{
				setEditPanelShow(false);
			}}>Close</div>
		</div>
		<div className='d-flex vh-100 align-items-center'>
			<div className='row vw-100' style={{marginTop:'-8rem'}}>
			<div className='col-md-5 mx-auto border rounded-2 p-4'>
				<div className='text-left fs-6 mb-4 text-secondary' ><i className="bi bi-info-square-fill"></i> Edit </div>
				<div className='formDiv'>
					<div className="mb-3">
						<label for="exampleFormControlInput1" className="form-label">[Old] {editLabel}</label>
						<input type="text" className="form-control" id="_evalueOld" value={editOldValue} placeholder="" disabled={true} />
					</div>
					<div className="mb-3">
						<label for="exampleFormControlInput1" className="form-label">[New] {editLabel}</label>
						{

							editKey==="handedOver"?
							<>
							<select className="form-control" id="_evalueNew" value={editNewValue} onChange={e=>setEditNewValue(e.target.value)}>
								<option value=""></option>	
								<option value="Yes">Yes</option>
								<option value="No">No</option>
							</select>
							</>
							:
							editKey==="inUse"?
							<>
							<select className="form-control" id="_evalueNew" value={editNewValue} onChange={e=>setEditNewValue(e.target.value)}>
								<option value=""></option>	
								<option value="Yes">Yes</option>
								<option value="No">No</option>
							</select>
							</>
							:
							editKey==="workStatus"?
								<>
								<select className="form-control" id="_evalueNew" value={editNewValue} onChange={e=>setEditNewValue(e.target.value)}>
									<option value=""></option>	
									<option value="Ongoing">Ongoing</option>
									<option value="Completed">Completed</option>
								</select>
								</>
							:
							editKey==="workProgress"?
								<>
								<select className="form-control" id="_evalueNew" value={editNewValue} onChange={e=>setEditNewValue(e.target.value)}>
										<option value="0">0%</option>
										<option value="5">5%</option>
										<option value="10">10%</option>
										<option value="15">15%</option>
										<option value="20">20%</option>
										<option value="25">25%</option>
										<option value="30">30%</option>
										<option value="35">35%</option>
										<option value="40">40%</option>
										<option value="45">45%</option>
										<option value="50">50%</option>
										<option value="55">55%</option>
										<option value="60">60%</option>
										<option value="65">65%</option>
										<option value="70">70%</option>
										<option value="75">75%</option>
										<option value="80">80%</option>
										<option value="85">85%</option>
										<option value="90">90%</option>
										<option value="95">95%</option>
										<option value="100">100%</option>
								</select>
								</>	
							:
							editKey==="assetType"?
								<>
								<select className="form-control" id="_evalueNew" value={editNewValue} onChange={e=>setEditNewValue(e.target.value)}>
									<option value=""></option>
									{
										assetsCategoryList && assetsCategoryList.map((ioption)=>{
											
											return(
													<option value={ioption.catId}>{ioption.catName}</option>
											);
										})
									}	
								</select>
								</>
							:
							editKey==="fundingAgency"?
								<>
								<select className="form-control" id="_evalueNew" value={editNewValue} onChange={e=>setEditNewValue(e.target.value)}>
								<option value=""></option>
									{
										fundingAgencyList && fundingAgencyList.map((ioption)=>{
											
											return(
													<option value={ioption}>{ioption}</option>
											);
										})
									}	
								</select>
								</>	
							:
							editKey==="userAgency"?
								<>
								<select className="form-control" id="_evalueNew" value={editNewValue} onChange={e=>setEditNewValue(e.target.value)}>
								<option value=""></option>
									{
										userAgencyList && userAgencyList.map((ioption)=>{
											
											return(
													<option value={ioption.userAgencyId}>{ioption.userAgencyName}</option>
											);
										})
									}	
								</select>
								</>			
							:
							editKey==="workFinishDate"?
							   <input type="date" className="form-control" id="_evalueNew" value={editNewValue} onChange={e=>setEditNewValue(e.target.value)} placeholder="" />
							:
								<input type="text" className="form-control" id="_evalueNew" value={editNewValue} onChange={e=>setEditNewValue(e.target.value)} placeholder="" />
						}
					</div>
					<div className="mb-3">
						<button type="submit" className="btn btn-primary mb-3" onClick={e=>updateRec(e)}>Confirm Update</button>
					</div>
				</div>
			</div>
			</div>
		</div>
	</div>
	</>
	}		

	{showImageBox===true &&
	<>
	<div className="position-fixed start-0 top-0 vw-100 vh-100 bg-light" style={{zIndex:99999999,opacity:0.95}}>
		<div className="d-flex justify-content-end p-4">
			<div className="cursor-pointer text-dark" onClick={()=>{
				setShowImageBox(false);
			}}>Close</div>
		</div>
		<div className='d-flex vh-100 align-items-center'>
			<div className='row vw-100' style={{marginTop:'-8rem'}}>
			<div className='col-md-5 mx-auto border rounded-2 p-4'>
				<div className='text-left fs-6 mb-4 text-secondary' ><i className="bi bi-info-square-fill"></i> Photo </div>
				<div className='text-center text-black fs-6'  >
				<img src={API_CORE_SERVER+"/_apistorage/"+selectedImages[0]} style={{maxWidth:'450px',maxHeight:'450px'}}  />
				</div>
				<div className='pt-4 text-end' >
					<button className='btn btn-secondary' onClick={()=>{
					setShowImageBox(false);
					}}>Close</button>
				</div>
			</div>
			</div>
		</div>
	</div>
	</>
	}
	
	{showQRBox===true &&
		<>
		<div className="position-fixed start-0 top-0 vw-100 vh-100 bg-light" style={{zIndex:99999999,opacity:0.95}}>
			<div className="d-flex justify-content-end p-4">
				<div className="cursor-pointer text-dark" onClick={()=>{
					setShowQRBox(false);
				}}>Close</div>
			</div>
			<div className='d-flex vh-100 align-items-center'>
				<div className='row vw-100' style={{marginTop:'-8rem'}}>
				<div className='col-md-5 mx-auto border rounded-2 p-4'>
					<div className='text-left fs-6 mb-4 text-secondary' ><i className="bi bi-info-square-fill"></i> Photo </div>
					<div className='text-center text-black fs-6'  >
					<img src={selectedQRImage} style={{maxWidth:'450px',maxHeight:'450px'}}  />
					</div>
					<div className='pt-4 text-end' >
						<button className='btn btn-secondary' onClick={()=>{
						setShowQRBox(false);
						}}>Close</button>
					</div>
				</div>
				</div>
			</div>
		</div>
		</>
	}		

	</>
    )
}

export default JComponent;